import cmp, {site} from "../../context/context";
import {AddtlConsent} from "../../addtl-consent/addtl-consent";
import {CustomConsent} from "../../custom-consent/custom-consent";

export interface IConsentData {
    listenerId: number;
    tcString: string;
    addtlConsent?: IConsent;
    customConsent?: IConsent;
    acceptanceLevel?: number;
}

interface IConsent {
    encoded: string;
    decoded: string;
}

export class ConsentData implements IConsentData {
    /* STATIC */
    public static build(listenerId: number) {
        return new ConsentData({
            listenerId,
            tcString: cmp().tcString?.toString()??"",
            addtlConsent: cmp().addtlConsent ? {
                encoded: site.addtlConsentParams()?.v === 1
                    ? (cmp().addtlConsent as AddtlConsent).encodedString()
                    : (cmp().addtlConsent as AddtlConsent).decodedString()
                ,
                decoded: (cmp().addtlConsent as AddtlConsent).decodedString()
            } : undefined,
            customConsent: cmp().customConsent ? {
                encoded: (cmp().customConsent as CustomConsent).encodedString(),
                decoded: (cmp().customConsent as CustomConsent).decodedString()
            }: undefined,
            acceptanceLevel: cmp().acceptanceLevel()
        });
    }

    /* INSTANCE */
    private constructor(private readonly _data: IConsentData) {
    }

    private get data(): IConsentData {
        return this._data;
    }

    public get listenerId(): number {
        return this.data.listenerId;
    }

    public get tcString(): string {
        return this.data.tcString;
    }

    public get addtlConsent(): IConsent|undefined {
        return this.data.addtlConsent;
    }

    public get customConsent(): IConsent|undefined {
        return this.data.customConsent;
    }

    public get acceptanceLevel(): number|undefined {
        return this.data.acceptanceLevel;
    }

}
